<div
  class="border-t pb-40 lg:pb-14"
  [style.backgroundColor]="colors()?.backgroundColor | contentBuilderColor: 'neutral-800'"
  [style.borderColor]="colors()?.borderColor | contentBuilderColor: 'neutral-600'"
>
  <div
    class="flex flex-col py-5 text-center text-sm text-white lg:justify-center lg:px-12 lg:text-left"
  >
    @if (hasExtras()) {
      <div class="w-full px-5">
        <app-block-list [blockIdList]="extras()"></app-block-list>
      </div>
    }
    @if (hasLinks()) {
      <div class="flex w-full items-center overflow-x-auto px-5 pr-4 scrollbar-hide">
        <app-block-list
          class="overflow-x-scroll bg-white"
          [blockIdList]="links()"
        ></app-block-list>
      </div>
    }
    @if (displayPoweredByDood()) {
      <div class="pt-2">
        <a
          class="flex w-full items-center justify-center gap-2 py-3"
          href="https://www.dood.com/corporate/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span class="text-xs font-normal">Powered by</span>
          <img
            class="h-6 w-auto"
            [src]="doodLogo()"
            [alt]="doodBrand + ' logo'"
          />
        </a>
      </div>
    }
  </div>
</div>
